import { DispatchItemsDto } from '../../../../../core';

export const detailDispatchWithdraw = {
    searchText: '',
    addText: '',
    checkbox: false,
    filter: false,
    filterDefault: '',
    disabled: false,
    partialField: '',
    paginatorAllData: true,
    show: 'No hay información para mostrar',
    columns: [
        {
            title: 'SKU',
            name: 'skuCode',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: DispatchItemsDto) => element.skuCode
        },
        {
            title: 'Descripción',
            name: 'skuName',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: DispatchItemsDto) => element.skuName
        },
        {
            title: 'Cantidad total',
            name: 'currentAmount',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: DispatchItemsDto) => (element.currentAmount != null) ? element.currentAmount : 0
        },
        {
            title: 'Cantidad entregada',
            name: 'pendingAmount',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: DispatchItemsDto) => (element.pendingAmount != null) ? element.pendingAmount : 0
        },
        {
            title: 'Estado',
            name: 'state',
            type: 'string',
            editable: false,
            checkAll: false,
            class: 'left',
            value: (element: DispatchItemsDto) => element.state
        },
        {
            title: 'Retirar',
            name: 'stateDispatch',
            type: 'boolean',
            toggleValue: () => true,
            editable: true,
            checkAll: true,
            class: 'center',
            value: (element: DispatchItemsDto) => element.stateDispatch
          }
    ]
};
